import { Input, InputMasks } from '@ui-components/neo.tax';
import * as React from 'react';

import { useUpdateCompanyQuestion, AnswerType, isValidIncorporationDate } from '@neo.tax/shared';

import { QuestionProps } from './company-info.types';

/**
 TODO: https://linear.app/neo-tax/issue/NEO-5514/use-react-hook-form-in-company-questions
 */
export const TextField: React.FC<QuestionProps> = ({
  question: { answerType, answerValue, id, placeholder, questionId },
}) => {
  const updateCompanyQuestionAnswer = useUpdateCompanyQuestion(id, questionId);
  switch (answerType) {
    case AnswerType.Ein:
      return (
        <Input
          onChange={(value): void => {
            updateCompanyQuestionAnswer({ answerValues: value.toString() });
          }}
          placeholder={placeholder ?? undefined}
          type="text"
          value={answerValue ?? ''}
          mask={InputMasks.EIN}
        />
      );
    case AnswerType.Date:
      return (
        <Input
          onChange={(value): void => {
            updateCompanyQuestionAnswer({ answerValues: value.toString(), validator: isValidIncorporationDate });
          }}
          placeholder={placeholder ?? undefined}
          type="text"
          value={answerValue ?? ''}
          mask={InputMasks.DATE}
          error={!!answerValue && !isValidIncorporationDate(answerValue ?? '')}
        />
      );
    default:
      return (
        <Input
          onChange={(e): void => {
            updateCompanyQuestionAnswer({ answerValues: e.target.value });
          }}
          placeholder={placeholder ?? undefined}
          type="text"
          value={answerValue ?? ''}
        />
      );
  }
};
